import { NullDefaultValueDirective } from './validators/null-number.directive';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { EmailValidator } from './validators/email-validator.directive';
import { UserNameValidator } from './validators/user-name-validator.directive';
import { DomainValidator } from './validators/domain-validator.directive';
import { Bounce } from './components/bounce/bounce.component';
import { SpinnerComponent } from './components/spinner/spinner.component';
import { ButtonsComponent } from './components/buttons/buttons.component';
import { TimePickerComponent } from './components/time-picker/time-picker.component';
import { ConfirmDialogComponent } from './components/confirm-dialog/confirm-dialog.component';
import { InfoDialogComponent } from './components/info-dialog/info-dialog.component';
import { ValidationMessagesComponent } from './components/validation-messages/validation-messages.component';
import { BzTabModule } from './components/tab/tab.module';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { RegularButtonComponent } from './components/regular-button/regular-button.component';
import { DateFilterComponent } from 'app/shared/components/date-filter/date-filter.component';
import { LoadingComponent } from './components/loading/loading.component';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { WizardComponent } from './components/wizard/wizard.component';
import { WizardStepWrapperComponent } from './components/wizard/step-wizard/step-wizard-wrapper';
import { Icon16Component, Icon32Component } from './components/icons/icons.component';
import { BzgLoaderModule } from './components/loader/loader.module';

import {
  BzgCoreModule,
  BzgButtonModule,
  BzgCheckboxModule,
  BzgIconModule,
  BzgInputModule,
  BzgMenuModule,
  BzgModalModule,
  BzgPasswordModule,
  BzgRadioModule,
  BzgSwitchModule,
  BzgTabsModule,
  BzgTextareaModule,
  BzgTimePickerModule,
  BzgToastModule,
  BzgTooltipModule,
  BzgWelcomeLandingModule,
  BzgPaginatorModule,
  BzgLoadingModule,
  BzgPopoverModule,
  BzgAutocompleteModule,
  BzgSelectModule,
  BzgSearchModule,
  BzgMessageModule,
  BzgAccordionModule,
  BzgTableModule,

} from 'bz-genome-angular';
import { DeleteConfirmationComponent } from './components/delete-confirmation/delete-confirmation.component';
import { PendingChangesConfirmationComponent } from './components/pending-changes-confirmation/pending-changes-confirmation.component';
import { BzgButtonToggleModule } from './components/button-toggle/button-toggle.module';
import { OrderByTranslatePipe } from './pipes/order-translate.pipe';
import { HttpUtilsService } from './services/http.utils.service';
import { OverlayService } from './services/overlay.service';
import { GenomeTimeService } from './services/genome-time.service';
import { SavePendingChangesComponent } from './components/save-pending-changes/save-pending-changes.component';
import { SearchByPipe } from './pipes/search-by.pipe';
import { OverlayModule } from '@angular/cdk/overlay';
import { RefreshComponent } from './components/refresh/refresh.component';
import { BzgDatePickerComponent } from './components/date-picker/date-picker.component';
import { AuthenticationTypeValidationSevice } from './services/authentication-type-validation.service';
import { BzgStatusPagesModule } from './components/status-pages/status-pages.module';
import { UniquePipe } from './pipes/unique.pipe';
import { PagerService } from './services/pager.service';
import { InputNumberOnlyDirective } from './validators/inputNumber';
import { SanitizeTextPipe } from './pipes/sanitize-text.pipe';
import { ResetConfirmationComponent } from './components/reset-confirmation/reset-confirmation.component';
import { TreeviewComponent } from './components/treeview/treeview.component';
import { TreeViewNodeComponent } from './components/treeview/treeviewnode/treeviewnode.component';
import { ActionConfirmationComponent } from './components/action-confirmation/action-confirmation.component';
import { AccordionComponent } from './components/accordion/accordion.component';
import { ShowDateFormat } from './pipes/show-date-format.pipe';
import { DateFilterTimeComponent } from './components/date-filter-time/date-filter-time.component';
import { TimezoneDisplayPipe } from './pipes/timezone-display.pipe';

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './i18n/', '.json');
}

@NgModule({
  imports: [
    TranslateModule.forChild({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
    BsDatepickerModule.forRoot(),
    CommonModule,
    FormsModule,
    BzTabModule,
    BzgCheckboxModule,
    BzgLoaderModule,
    BzgModalModule,
    BzgToastModule,
    BzgButtonModule,
    BzgTooltipModule,
    BzgMenuModule,
    BzgIconModule,
    BzgTabsModule,
    BzgInputModule,
    BzgSwitchModule,
    BzgRadioModule,
    BzgButtonToggleModule,
    BzgWelcomeLandingModule,
    BzgPaginatorModule,
    BzgAccordionModule,
    BzgTableModule,
    BzgLoadingModule,
    OverlayModule,
    BzgPopoverModule,
    BzgAutocompleteModule,
    BzgSelectModule,
    BzgSearchModule,
    BzgStatusPagesModule,
    BzgCoreModule,
    BzTabModule,
    BzgMessageModule,
  ],
  exports: [
    FormsModule,
    EmailValidator,
    Bounce,
    ButtonsComponent,
    ValidationMessagesComponent,
    ConfirmDialogComponent,
    UserNameValidator,
    DomainValidator,
    NullDefaultValueDirective,
    InputNumberOnlyDirective,
    InfoDialogComponent,
    RegularButtonComponent,
    TimePickerComponent,
    DateFilterComponent,
    DateFilterTimeComponent,
    LoadingComponent,
    WizardComponent,
    WizardStepWrapperComponent,
    Icon16Component,
    Icon32Component,
    BsDatepickerModule,
    BzgCheckboxModule,
    BzgLoaderModule,
    BzgModalModule,
    BzgToastModule,
    BzgButtonModule,
    BzgTooltipModule,
    BzgMenuModule,
    BzgIconModule,
    BzgTabsModule,
    BzgInputModule,
    BzgTextareaModule,
    BzgTimePickerModule,
    BzgPasswordModule,
    DeleteConfirmationComponent,
    BzgSwitchModule,
    BzgRadioModule,
    BzgButtonToggleModule,
    OrderByTranslatePipe,
    BzgWelcomeLandingModule,
    BzgPaginatorModule,
    BzgAccordionModule,
    BzgTableModule,
    BzgLoadingModule,
    BzgPopoverModule,
    OverlayModule,
    SearchByPipe,
    UniquePipe,
    ShowDateFormat,
    TimezoneDisplayPipe,
    SanitizeTextPipe,
    BzgAutocompleteModule,
    BzgSelectModule,
    BzgSearchModule,
    BzgMessageModule,
    BzgCoreModule,
    RefreshComponent,
    BzgDatePickerComponent,
    BzgStatusPagesModule,
    ResetConfirmationComponent,
    TreeviewComponent,
    TreeViewNodeComponent,
    AccordionComponent,
    ActionConfirmationComponent
  ],
  declarations: [
    EmailValidator,
    Bounce,
    SpinnerComponent,
    ButtonsComponent,
    TimePickerComponent,
    ValidationMessagesComponent,
    ConfirmDialogComponent,
    UserNameValidator,
    DomainValidator,
    NullDefaultValueDirective,
    InputNumberOnlyDirective,
    InfoDialogComponent,
    RegularButtonComponent,
    DateFilterComponent,
    DateFilterTimeComponent,
    LoadingComponent,
    WizardComponent,
    WizardStepWrapperComponent,
    Icon16Component,
    Icon32Component,
    DeleteConfirmationComponent,
    PendingChangesConfirmationComponent,
    OrderByTranslatePipe,
    SavePendingChangesComponent,
    SearchByPipe,
    UniquePipe,
    ShowDateFormat,
    TimezoneDisplayPipe,
    SanitizeTextPipe,
    RefreshComponent,
    BzgDatePickerComponent,
    ResetConfirmationComponent,
    TreeviewComponent,
    TreeViewNodeComponent,
    AccordionComponent,
    ActionConfirmationComponent
  ],
  entryComponents: [
    WizardComponent,
    DeleteConfirmationComponent,
    PendingChangesConfirmationComponent,
    SavePendingChangesComponent,
    ResetConfirmationComponent,
    ActionConfirmationComponent
  ],
  providers: [HttpUtilsService, OverlayService, GenomeTimeService, AuthenticationTypeValidationSevice, PagerService]
})

export class SharedModule { }
